module.exports = __webpack_public_path__ + "media/components/country-flag/static/gs-f9cbcdd501018ba5bd1a761ce8b85030.svg";